import { mixLogin } from '@/services'
import { setMixAuth } from '@/lib/storage'
import i18n from '@/lib/language'
const store = {
  namespaced: true,
  state: {
    visible: false,
    submitting: false,
    callbacks: [],
    profile: {},
    decorators: {
      mixPassword: ['password', { rules: [{ required: true, message: i18n.t('message["784"]') }] }]
    }
  },
  getters: {
    userid (state, getters, rootState) {
      return rootState.baseinfo.userid
    }
  },
  mutations: {
    // 关闭弹窗
    show (state) {
      state.visible = true
    },
    // 关闭弹窗
    hide (state) {
      state.visible = false
    },
    // 设置登录表单提交状态
    setSubmitting (state, type) {
      state.submitting = !!type
    }
  },
  actions: {
    // 登录链
    async loginChain ({ state, commit, rootGetters }) {
      commit('setSubmitting', true)
      return mixLogin()
        .onRequest(async (config = {}) => {
          if (config.headers) {
            delete config.headers.Authorization
          }
          config.baseURL = rootGetters.mixDomain
          return config
        }, '#100')
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .onSuccess(async (payload = {}) => {
          setMixAuth(payload.auth)
        })
    }
  }
}
export default store
